import React, { Component } from 'react';
import GoogleFloodlight from './GoogleFloodlight';
import PropTypes from 'prop-types';

export default class GoogleFloodlightWrapper extends Component {
    render() {
        return(
            <div>
                <GoogleFloodlight
                  config={this.props.config}
                  reportEvent={this.props.reportEvent}
                />
            </div>
        );
    }
}

GoogleFloodlightWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
